import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import axios from 'axios'; // eslint-disable-line import/no-extraneous-dependencies
import * as types from '../constants/ActionTypes';

import Page from '../../lib/page';
import { topicSearchPool, getTopicId } from '../../lib/crawlSearchHelper';
import { getSearchObject, hideSearchBar } from './action-crawl-intent-topic';
import { fetchFormElementsNoIntent, getPrivacyHardCodeForm } from './action-email-no-intent';
import { trackSetUp } from '../../lib/analytics-helper';
import { getLastPathVariable } from '../../lib/location-helper';
import { privacyRefId } from '../constants/UtilVariables';

const TOPIC_TREE_URL = '/smarthelp/topic-tree';
const hardcodeGroupEmail = 'groupEmail';

const TOPIC_MESSAGE = 'topictree request canceled';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

function requestTopicTreeData() {
  return {
    type: types.REQUEST_TOPIC_TREE,
    payload: undefined,
  };
}

function receiveTopicTreeData(options = {}) {
  return {
    type: types.RECEIVE_TOPIC_TREE_RESPONSE,
    payload: options.topicTree,
  };
}

function receiveTopicTreeDataError(options = {}) {
  if (options.email || options.logoutEmail) {
    // FPTI tracking error for no topic tree in EmailByPass page
    trackSetUp({
      id: `${getLastPathVariable(window.location)}TopicTreeDataError`,
      link: `smarthelp-topic-tree-data-error-${getLastPathVariable(
        window.location,
      )}-page`,
    });
  }
  return (dispatch) => dispatch({
    type: types.RECEIVE_TOPIC_TREE_ERROR,
    payload: true,
  });
}

function updateLogoutFormTopicName(topicInfo) {
  return {
    type: types.UPDATE_LOGOUT_EMAIL_TOPIC,
    payload: topicInfo,
  };
}

function getTopicTreeUrl() {
  if (!Page.isUsingHardcodeEmailForm()) {
    return TOPIC_TREE_URL;
  }
  return Page.setURLQuery(TOPIC_TREE_URL, hardcodeGroupEmail, 'true');
}

export function fetchTopicTree(options) {
  return (dispatch, getState) => {
    dispatch(requestTopicTreeData());
    return axios.get(getTopicTreeUrl(), {
      cancelToken: source.token,
    })
      .then((response) => {
        const topicTree = _get(response.data, 'topicTree.contact_email_template', {});
        const subtopics = topicTree && topicTree.sub_topics;

        if (Array.isArray(subtopics) && subtopics.length > 0) {
          const params = { ...options, topicTree };
          dispatch(receiveTopicTreeData(params));
          const searchPool = topicSearchPool(topicTree);

          if (options && options.logoutEmail) {
            // Getting hardcode Email form for group markets and email query is privacy form
            if (Page.isUsingHardcodeEmailForm() && options.emailRef === privacyRefId) {
              const privacyEmail = Page.getHardcodePrivacyEmailForm(searchPool);
              const webForm = {
                webForms: privacyEmail && privacyEmail.web_forms,
                topicRefId: privacyRefId,
              };
              dispatch(updateLogoutFormTopicName(privacyEmail));
              dispatch(getPrivacyHardCodeForm(webForm));
            } else {
              // Logout Email form topic tree for getting topic id for localized markets
              const topicInfo = getTopicId({ query: options.emailRef, searchPool });
              if (!_isEmpty(topicInfo)) { // Not Topic Id, when the RefId find
                dispatch(fetchFormElementsNoIntent(topicInfo.topic_id, true));
                dispatch(updateLogoutFormTopicName(topicInfo));
              } else {
                dispatch(receiveTopicTreeDataError(options));
              }
            }
          } else {
            // Fetch Search pool for the Channel Steering page
            dispatch(getSearchObject(searchPool)); // Getting intent topic search pool

            // Hide search object for chatBot final topic intent
            const modalChannel = _get(getState(), 'modal.channel');
            const isCameFromANWRedirect = _get(getState(), 'persistedStepUp.anw.isRedirectedToAnw');
            const selectedResult = _get(getState(), 'selectResult.topicTreeSelectResult');

            if (!_isEmpty(selectedResult) || isCameFromANWRedirect) {
              dispatch(hideSearchBar());
            } else if (modalChannel === 'emailUs' && Page.isPilotUser()) {
              // Hide Search Bar for Pilot users selecting Email option in the topic final intent
              dispatch(hideSearchBar());
            }
          }
        } else {
          dispatch(receiveTopicTreeDataError(options));
        }
        return true;
      })
      .catch((error) => {
        if (error && error.message !== TOPIC_MESSAGE) {
          dispatch(receiveTopicTreeDataError(options));
        }
      });
  };
}

export function cancelTopicTreeRequest() {
  source.cancel(TOPIC_MESSAGE);
}
